/* Fetch only a likely next public page. Navigation and app lifecycles remain native. */
(() => {
  const connection = navigator.connection;
  if (window.Shopify?.designMode || connection?.saveData || /(^|-)2g$/.test(connection?.effectiveType || '')) return;
  const seen = new Set();
  let timer;
  function destination(target) {
    const link = target.closest?.('a[href]');
    if (!link || link.target || link.hasAttribute('download') || link.closest('[data-no-prefetch]')) return;
    const url = new URL(link.href, location.href);
    if (url.origin !== location.origin || url.hash || !/^\/(?:products|collections|pages|blogs)\//.test(url.pathname)) return;
    if (url.pathname === '/collections/all' && !url.search) {
      url.searchParams.set('sort_by', 'best-selling');
      link.href = url.href;
    }
    if ([...url.searchParams.keys()].some(key => key !== 'sort_by') || url.href === location.href) return;
    return url.href;
  }
  function prefetch(href) {
    if (!href || seen.has(href) || seen.size >= 4 || document.visibilityState !== 'visible' || !navigator.onLine) return;
    seen.add(href);
    const hint = document.createElement('link');
    hint.rel = 'prefetch'; hint.as = 'document'; hint.href = href;
    document.head.appendChild(hint);
  }
  document.addEventListener('pointerover', event => {
    if (event.pointerType !== 'mouse') return;
    clearTimeout(timer);
    const href = destination(event.target);
    if (href) timer = setTimeout(() => prefetch(href), 140);
  }, {passive:true});
  document.addEventListener('pointerout', () => clearTimeout(timer), {passive:true});
  document.addEventListener('focusin', event => prefetch(destination(event.target)));
  document.addEventListener('pointerdown', event => { destination(event.target); }, {passive:true});
})();
